import type { Epicycle } from "../math/epicycles";
import { fourierConfig as config } from "../config";
import { EpicycleChain } from "./EpicycleChain";
import { FourierTrail } from "./FourierTrail";

/** Both panels share one chain evaluation; only their screen origins differ. */
export const SplitFourierScene = ({
  chain,
  path,
  opacity = 1,
  circleOpacity = 1,
  tipOpacity = 1,
  glow = 0.25,
  target = {
    x: config.layout.targetX,
    y: config.layout.y,
    scale: config.layout.scale,
  },
  colors = config.colors,
  trailWidth = config.trailWidth,
}: {
  chain: readonly Epicycle[];
  path: string;
  opacity?: number;
  circleOpacity?: number;
  tipOpacity?: number;
  glow?: number;
  target?: { x: number; y: number; scale: number };
  colors?: { trail: string; circle: string; vector: string; background: string };
  trailWidth?: number;
}) => {
  const { x, y, scale } = config.layout;
  const tip = chain[chain.length - 1].tip;
  return (
    <g opacity={opacity}>
      <line
        x1={x + tip.x * scale}
        y1={y + tip.y * scale}
        x2={target.x + tip.x * target.scale}
        y2={target.y + tip.y * target.scale}
        stroke={colors.trail}
        strokeWidth={3}
        strokeDasharray="10 8"
        strokeLinecap="round"
        opacity={circleOpacity * 0.85}
      />
      <g transform={`translate(${x} ${y}) scale(${scale})`}>
        <EpicycleChain chain={chain} opacity={circleOpacity} colors={colors} />
        <g opacity={circleOpacity}>
          {glow > 0 && <circle
            cx={tip.x}
            cy={tip.y}
            r={15 / scale}
            fill={colors.trail}
            opacity={0.55}
            filter="url(#tip-glow)"
          />}
          <circle cx={tip.x} cy={tip.y} r={5.8 / scale} fill={colors === config.colors ? "#FFF2FA" : colors.trail} />
        </g>
      </g>
      <g
        transform={`translate(${target.x} ${target.y}) scale(${target.scale})`}
      >
        <FourierTrail
          path={path}
          tip={tip}
          tipOpacity={tipOpacity}
          glow={glow}
          scale={target.scale}
          colors={colors}
          trailWidth={trailWidth}
        />
      </g>
    </g>
  );
};

